import React from 'react';

function Contact() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="kontakt-heading"
    >
      <div className="home-header">
        <h1 id="kontakt-heading">KONTAKT</h1>
      </div>

      <section aria-labelledby="kontakt-info">
        <h2 id="kontakt-info" className="visually-hidden">
          Kontaktinformationen
        </h2>

        <p>
          <strong>Kontaktieren Sie uns:</strong>
        </p>

        <p>
          <strong>Dr. Ernst Leitgeb</strong><br />
          Institutsleiter<br />
          Institut für Waldökologie und Boden<br />
          BFW
        </p>

        <p>
          <strong>Telefon:</strong> +43-1-878 38 – 1201<br />
          <a href="mailto:ernst.leitgeb@bfw.gv.at">
            ernst.leitgeb@bfw.gv.at
          </a>
        </p>

        <p>
          <strong>Mag. Karl Gartner</strong><br />
          Stellv. Abteilungsleiter<br />
          Abteilung Standort und Vegetation<br />
          Institut für Waldökologie und Boden<br />
          BFW
        </p>

        <p>
          <strong>Telefon:</strong> +43-1-878 38 – 1344<br />
          <strong>E-Mail:</strong>{' '}
          <a href="mailto:karl.gartner@bfw.gv.at">
            karl.gartner@bfw.gv.at
          </a>
        </p>
      </section>
    </div>
  );
}

export default Contact;
